module.exports = __webpack_public_path__ + "img/image (4).dc3160b7.jpg";